/* Scope motion handling to the hero's secondary action; preserve native forms. */
(function () {
  'use strict';
  function init() {
    var link = document.querySelector('.rtp-s1__inside[href="#opportunity"]');
    if (!link || link.dataset.rtpMotionReady) return;
    link.dataset.rtpMotionReady = 'true';
    link.addEventListener('click', function (event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      // The theme supplies native smooth scrolling. Override only reduced motion.
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var target = document.getElementById('opportunity');
      if (!target) return;
      event.preventDefault();
      window.history.pushState(null, '', link.hash);
      target.scrollIntoView({ behavior: 'instant', block: 'start' });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

/* Mobile-only decorative playback and measured photographic safe area. */
(function () {
  'use strict';
  function initMotion() {
    var video = document.querySelector('[data-rtp-s1-video]');
    if (!video || video.dataset.ready) return;
    video.dataset.ready = 'true';
    var hero = video.closest('.rtp-s1');
    var copy = hero.querySelector('.rtp-s1__copy');
    var mobile = window.matchMedia('(max-width: 749px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var visible = false, finished = false, pending = false, attempts = 0;
    var timer, observer, resize, finalImage, finalReady, disposed = false;
    var artVariant, sourceHeight = 740, artFits = true, layoutReady = !document.fonts;
    var activeSrc = video.dataset.src, activeFinal = video.dataset.final, activeFallback = video.dataset.fallback;
    var pictureSource = hero.querySelector('.rtp-s1__photograph source');
    function measure() {
      if (disposed) return;
      if (!mobile.matches) { hero.style.removeProperty('--rtp-s1-art-height'); return; }
      var rect = hero.getBoundingClientRect();
      var available = Math.max(0, copy.getBoundingClientRect().top - rect.top - 20);
      var sourceSpace = rect.width ? available * 720 / rect.width : 0;
      var variant = sourceSpace >= 740 ? '' : sourceSpace >= 460 ? 'Compact' : 'Short';
      sourceHeight = variant === '' ? 740 : variant === 'Compact' ? 460 : 350;
      artFits = sourceSpace >= 310;
      var height = Math.min(available, rect.width * sourceHeight / 720);
      var value = height + 'px';
      if (hero.style.getPropertyValue('--rtp-s1-art-height') !== value) hero.style.setProperty('--rtp-s1-art-height', value);
      video.dataset.artVariant = variant || 'Tall';
      video.dataset.artHeight = String(sourceHeight);
      hero.style.setProperty('--rtp-s1-floor-image', 'var(--rtp-s1-floor-' + (variant || 'tall').toLowerCase() + ')');
      if (artVariant !== variant) {
        var wasComplete = video.dataset.motionState === 'complete';
        if (video.hasAttribute('src') && !finished) finish(false, 'viewport-crop-change');
        artVariant = variant;
        activeSrc = video.dataset['src' + variant];
        activeFinal = video.dataset['final' + variant];
        activeFallback = video.dataset['fallback' + variant];
        pictureSource.srcset = activeFallback;
        pictureSource.setAttribute('width', '720'); pictureSource.setAttribute('height', String(sourceHeight));
        if (finalImage) { finalImage.remove(); finalImage = null; finalReady = null; }
        if (wasComplete && artFits && !reduce.matches) prepareFinal().then(function (loaded) {
          if (loaded && finalImage && mobile.matches && !reduce.matches) finalImage.setAttribute('data-visible', '');
        });
      }
    }
    function clearTimer() { window.clearTimeout(timer); }
    function release() {
      clearTimer(); pending = false;
      video.removeAttribute('data-active'); video.pause();
      if (video.hasAttribute('src')) { video.removeAttribute('src'); video.load(); }
      video.removeAttribute('poster');
    }
    function prepareFinal() {
      if (finalReady) return finalReady;
      finalImage = new Image(720, sourceHeight);
      finalImage.className = 'rtp-s1__settled'; finalImage.alt = ''; finalImage.setAttribute('aria-hidden', 'true');
      finalImage.src = activeFinal;
      hero.insertBefore(finalImage, hero.querySelector('.rtp-s1__inner'));
      finalReady = finalImage.decode().then(function () { return true; }, function () { return false; });
      return finalReady;
    }
    function finish(success, reason) {
      if (finished) return;
      finished = true; clearTimer(); video.pause();
      video.dataset.motionState = success ? 'settling' : 'fallback';
      if (reason) video.dataset.motionReason = reason;
      if (observer) observer.disconnect();
      if (success) prepareFinal().then(function (loaded) {
        if (disposed) return;
        if (loaded && finalImage && mobile.matches && !reduce.matches) { finalImage.setAttribute('data-visible', ''); video.dataset.motionState = 'complete'; }
        else { video.dataset.motionState = 'fallback'; video.dataset.motionReason = loaded ? 'preference-change' : 'poster-load-failed'; }
        release();
      });
      else release();
    }
    function eligible() { return mobile.matches && layoutReady && artFits && !reduce.matches && visible && !document.hidden && !finished && !disposed; }
    function guard() { clearTimer(); if (eligible()) timer = window.setTimeout(function () { finish(false, 'load-or-stall-timeout'); }, 12000); }
    function update() {
      measure();
      if (!mobile.matches || reduce.matches) {
        if (finalImage) finalImage.removeAttribute('data-visible');
        if (video.hasAttribute('src')) finish(false, reduce.matches ? 'reduced-motion' : 'desktop-transition');
        release(); return;
      }
      if (!eligible()) { clearTimer(); video.pause(); return; }
      if (pending || !video.paused) return;
      if (attempts >= 3) { finish(false, 'retry-limit'); return; }
      if (!video.hasAttribute('src')) {
        video.muted = true; video.defaultMuted = true; video.playsInline = true;
        video.poster = activeFallback;
        video.setAttribute('data-active', '');
        video.src = activeSrc;
      }
      pending = true; attempts += 1; guard(); video.dataset.motionState = 'starting';
      var attempt = video.play();
      if (attempt && attempt.then) attempt.then(function () {
        pending = false; if (!eligible()) video.pause();
      }).catch(function (error) {
        pending = false;
        video.dataset.motionReason = error.name;
        video.dataset.motionReadyState = String(video.readyState);
        video.dataset.motionNetworkState = String(video.networkState);
        if (error.name === 'AbortError') { if (eligible()) window.setTimeout(update, 150); }
        else if (eligible()) finish(false, error.name);
      });
      else pending = false;
    }
    video.addEventListener('playing', function () {
      clearTimer();
      if (eligible()) { video.dataset.motionState = 'playing'; prepareFinal(); }
      else video.pause();
    });
    video.addEventListener('ended', function () { finish(true); });
    video.addEventListener('error', function () { if (video.hasAttribute('src')) finish(false, 'media-error-' + (video.error ? video.error.code : 'unknown')); });
    video.addEventListener('waiting', guard); video.addEventListener('stalled', guard);
    function listen(mq) { if (mq.addEventListener) mq.addEventListener('change', update); else mq.addListener(update); }
    function unlisten(mq) { if (mq.removeEventListener) mq.removeEventListener('change', update); else mq.removeListener(update); }
    listen(mobile); listen(reduce);
    window.addEventListener('resize', measure);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', measure);
    if ('ResizeObserver' in window) { resize = new ResizeObserver(measure); resize.observe(hero); resize.observe(copy); }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { layoutReady = true; update(); });
    document.addEventListener('visibilitychange', update); window.addEventListener('pageshow', update);
    function pause() { clearTimer(); video.pause(); }
    window.addEventListener('pagehide', pause);
    function unload(event) {
      if (!event.target.contains(hero)) return;
      disposed = true; release();
      if (observer) observer.disconnect(); if (resize) resize.disconnect();
      unlisten(mobile); unlisten(reduce); window.removeEventListener('resize', measure);
      if (window.visualViewport) window.visualViewport.removeEventListener('resize', measure);
      document.removeEventListener('visibilitychange', update); window.removeEventListener('pageshow', update); window.removeEventListener('pagehide', pause);
      document.removeEventListener('shopify:section:unload', unload);
    }
    document.addEventListener('shopify:section:unload', unload);
    measure();
    if (!('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; update(); }, { threshold: 0 });
    observer.observe(hero);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMotion);
  else initMotion();
  document.addEventListener('shopify:section:load', initMotion);
})();
